"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/************************************** THIRD-PARTY MODULES ***************************************/
var mad_utils_1 = require("mad-utils");
var javelin_exports_1 = require("../javelin-exports");
/********************************* EXPORT DATA WITH TYPES APPLIED *********************************/
exports.Disease = javelin_exports_1.javelin.data.model.schedule.Disease;
mad_utils_1.defineProp(exports.Disease.prototype, 'JVLN_CLASS_NAME', 'Disease', false);
//# sourceMappingURL=disease.js.map